
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("3AaIE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "GLOBAL_SCOPE_ROUTES", () => $8a64f2098c4cafd9$export$f47036775f4cb978);
$parcel$export(module.exports, "default", () => $8a64f2098c4cafd9$export$2e2bcd8739ae039);

var $1rJV8 = parcelRequire("1rJV8");

var $guiFP = parcelRequire("guiFP");

var $ABYiz = parcelRequire("ABYiz");
const $8a64f2098c4cafd9$export$f47036775f4cb978 = [
    (0, $1rJV8.ROUTE_NAMES).GLOBAL_ISSUE_NAVIGATOR,
    (0, $1rJV8.ROUTE_NAMES).GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a64f2098c4cafd9$export$2e2bcd8739ae039 = async (routerContext, customContext)=>{
    // If we're rendering Global Scope in SSR then we can assume the user is enrolled, as the monolith has decided to
    // send the request to Jira Frontend
    const isGlobalScopeRoute = $8a64f2098c4cafd9$export$f47036775f4cb978.includes(routerContext.route.name);
    if (false && isGlobalScopeRoute) return true;
    try {
        return await (0, $ABYiz.default)(customContext.tenantContext.cloudId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $guiFP.default)({
            meta: {
                id: 'jiraNinGlobalScopeEnrolmentEnabledResource',
                packageName: 'jiraRouterResourcesIsNinGlobalScopeEnrolmentEnabled',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return false;
    }
};

});
parcelRegister("ABYiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1983ebf9a0563476$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");
const $1983ebf9a0563476$var$SELECTED_GLOBAL_SCOPE_ISSUE_NAVIGATOR_QUERY = `
    query SelectedGlobalScopeIssueNavigatorQuery($cloudId: ID!) {
        myPreferences(keys: [
            "jira.user.nin.global.scope.enrolment"
        ]),
        jira {
            applicationPropertiesByKey(cloudId: $cloudId, keys: ["jira.admin.nin.global.scope.enrolment"]) {
                value
            }
        }
    }
`;
const $1983ebf9a0563476$var$fetchIsGlobalScopeEnrolmentEnabledFromServer = async (cloudId)=>{
    const apiResult = await (0, $lRmyA.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $1983ebf9a0563476$var$SELECTED_GLOBAL_SCOPE_ISSUE_NAVIGATOR_QUERY,
            variables: {
                cloudId: cloudId
            }
        })
    });
    const userPreferenceValue = apiResult.data.myPreferences['jira.user.nin.global.scope.enrolment'];
    if (userPreferenceValue !== 'nin' && userPreferenceValue !== 'gin' && userPreferenceValue !== null) throw new RangeError('Unexpected user preference value');
    const applicationPropertyValue = apiResult.data.jira.applicationPropertiesByKey[0].value;
    if (applicationPropertyValue !== 'true' && applicationPropertyValue !== 'false') throw new RangeError('Unexpected application property value');
    return userPreferenceValue !== 'gin' && applicationPropertyValue === 'true';
};
var $1983ebf9a0563476$export$2e2bcd8739ae039 = $1983ebf9a0563476$var$fetchIsGlobalScopeEnrolmentEnabledFromServer;

});



//# sourceMappingURL=async-resource-issue-navigator-global-scope-enrolment.22c2c8e8.js.map
